import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSort = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M19.999 12.285a1.285 1.285 0 0 0 .909-2.194l-7.714-7.714a1.285 1.285 0 0 0-1.818 0l-7.714 7.714a1.285 1.285 0 1 0 1.818 1.818L11 6.389v30.324a1.29 1.29 0 0 0 1.285 1.286c.707 0 1.285-.575 1.285-1.286V6.39l5.52 5.52c.25.247.58.375.909.375Zm16.336 15.806a1.284 1.284 0 0 0-1.817-.001l-5.52 5.521V3.286c0-.71-.578-1.286-1.285-1.286s-1.286.575-1.286 1.286V33.61l-5.52-5.52a1.285 1.285 0 1 0-1.817 1.818l7.714 7.714a1.285 1.285 0 0 0 1.818 0l7.714-7.714a1.28 1.28 0 0 0-.001-1.818Z" })
});
export default SvgSort;
